// extracted by mini-css-extract-plugin
module.exports = {"eventContainer":"events_eventContainer__1YGC5","calendar":"events_calendar__3laxg","eventDay":"events_eventDay__1oKiM","event":"events_event__UPz36","item":"events_item__1abpW"};